"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var Account = /*#__PURE__*/function () {
  function Account(client) {
    (0, _classCallCheck2["default"])(this, Account);
    this.client = client;
    this.resourceUrl = '/accounts';
  }

  (0, _createClass2["default"])(Account, [{
    key: "getAccountReport",
    value: function getAccountReport(startDate, endDate, reportFor, coachId, organization, network) {
      var queryString = "?startDate=".concat(startDate, "&endDate=").concat(endDate, "&reportFor=").concat(reportFor);

      if (coachId !== '') {
        queryString += "&coachId=".concat(coachId);
      }

      if (organization) {
        queryString += "&company=".concat(organization);
      }

      if (network) {
        queryString += "&network=".concat(network);
      }

      for (var _len = arguments.length, args = new Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
        args[_key - 6] = arguments[_key];
      }

      return this.client.get("".concat(this.resourceUrl).concat(queryString), args);
    }
  }, {
    key: "markAsPaid",
    value: function markAsPaid(startDate, endDate, reportFor, coachId, organization, network) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 6 ? _len2 - 6 : 0), _key2 = 6; _key2 < _len2; _key2++) {
        args[_key2 - 6] = arguments[_key2];
      }

      return this.client.get("".concat(this.resourceUrl, "/mark-as-paid?startDate=").concat(startDate, "&endDate=").concat(endDate, "&reportFor=").concat(reportFor, "&coachId=").concat(coachId).concat(organization ? "&company=".concat(organization) : '').concat(network ? "&network=".concat(network) : ''), args);
    }
  }]);
  return Account;
}();

exports["default"] = Account;